import Button from 'atoms/Button/button';
import JoditEditorWrapper from 'components/general/Form/JoditEditor';
import { Box } from 'components/molecules/utils/basicComponents';
import { Typography } from 'foundations/typography';
import React from 'react';
import styled from 'styled-components';
import { Organiser } from '../FormFields/Organiser';
import SupportEmail from '../FormFields/SupportEmail';

function EventDetails({ formData, onValueChange, errors, pageMode, mode }) {
    const handleLongDescChanged = (content) => {
        onValueChange && onValueChange('longDesc', content);
    };

    return (
        <Box>
            <Typography variant={'subtext0'} color={'ambience.1'} mb={1}>
                About the event
            </Typography>
            <StyledEditor>
                <JoditEditorWrapper
                    key='longDesc'
                    id='longDesc'
                    name='longDesc'
                    editorContent={formData?.longDesc}
                    onChangeHandler={handleLongDescChanged}
                    config={{ height: '190px' }}
                />
            </StyledEditor>
            <Box className='form-field-outer' pt={3}>
                <Organiser
                    formData={formData}
                    mode={mode}
                    errors={errors}
                    pageMode={pageMode}
                    label='Organizer name'
                    hideSubLabel={true}
                    onChange={(e) =>
                        onValueChange('eventOrganiserName', e?.target?.value)
                    }
                />
            </Box>
            <Box className='form-field-outer' py={3}>
                <SupportEmail
                    formData={formData}
                    errors={errors}
                    pageMode={pageMode}
                    onChange={(e) =>
                        onValueChange('supportEmail', e?.target?.value)
                    }
                />
            </Box>
        </Box>
    );
}

export default EventDetails;

const StyledEditor = styled(Box)`
    > div {
        flex: 1;
        padding: 0;
        margin: 0;
    }
    textarea {
        opacity: 0;
    }
`;

export const TooltipContent = styled(Box)`
    padding: 16px 24px;
    background: ${({ theme }) => theme.colors.ambience[0]};
    border-radius: 8px;
    max-width: 262px;
`;

export const StyledButton = styled(Button)`
    cursor: ${({ isDisabled }) => (isDisabled ? 'not-allowed' : 'pointer')};
    p {
        color: ${({ theme, isDisabled }) =>
            isDisabled && theme.colors.ambience[14]};
    }
`;
